module.exports = __webpack_public_path__ + "img/istay-orange.b5d8a4d5.png";